import {
  AppBar,
  Box,
  Button,
  Grid,
  Toolbar,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import { useEffect, useState } from 'react';
import HeaderGrid from '../components/HeaderGrid';
import MessageIcon from '@material-ui/icons/Message';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import KenDialogBox from '../../../global_components/KenDialogBox';
import Webcam from 'react-webcam';
import '../../../style/index.css';
import KenButton from '../../../global_components/KenButton';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import {
  getExamData,
  getStudentRiskDataData,
  getCourseWithoutExam,
} from '../../../Utils/apiServices';
import KenLoader from '../../../Components/KenLoader';
import { sendMailExamData } from '../../../Utils/sendMail';
import { RiCheckFill } from 'react-icons/ri';
import { toast, ToastContainer } from 'react-toastify';
const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'EXAM DASHBOARD',
  },
];

const dataProgress = [
  {
    id: 1,
    program: 'GMBA',
    subject: 'Subject 1',
    type: 'Offline',
    actions: 'Room 101',
  },
  {
    id: 2,
    program: 'EMBA',
    subject: 'Subject 2',
    type: 'Onlie',
    actions: 'Room 101',
  },
  {
    id: 3,
    program: 'GMBA',
    subject: 'Subject 3',
    type: 'Offline',
    actions: 'Room 101',
  },
  {
    id: 4,
    program: 'GMBA',
    subject: 'Subject 4',
    type: 'Offline',
    actions: 'Room 101',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    height: '28px',
    width: '78px',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
    fontSize: '9px !important',
    height: '35px !important',
  },
  error: {
    // color: '#F14B2D',
    width: '100px',
    color: 'white',
    margin: '5px 5px',
    fontSize: '10px',
    background: 'orange',
    borderRadius: '10px',
    height: '35px',
    '&:hover': {
      background: 'orange',

      // color: 'white',
      // borderBottom: '#F14B2D',
    },
  },
  normal: {
    // color: '#505F79',
    width: '100px',
    color: 'white',
    margin: '5px 5px',
    fontSize: '10px',
    background: 'green',
    borderRadius: '10px',
    height: '35px',
    '&:hover': {
      background: '#00c04b',

      color: 'white',
      // border: '1px solid white',
    },
  },
  penddingButton: {
    // color: '#505F79',
    color: 'white',
    width: '100px',
    height: '35px',
    background: '#55b0cd',
    // background: '#27AE60',

    // background: 'white',
    width: '100px',
    borderRadius: '10px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',
      color: 'white',
      // border: '1px solid white',
    },
  },

  errorEvulations: {
    // color: '#F14B2D',

    background: 'rgba(241, 75, 45, 0.2)',
    // background: 'white',
    // background: '#EB5757',

    borderRadius: '25px',
    border: '1px solid white',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px  5px',
    color: 'white',
    '&:hover': {
      color: 'white',
      background: 'rgba(241, 75, 45, 0.2)',

      // color: 'white',
      // borderBottom: '#F14B2D',
    },
  },
  grayButton: {
    // color: '#505F79',
    color: 'white',

    background: 'rgba(196, 196, 196,0.2)',
    // background: '#27AE60',

    // background: '#505F79',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(196, 196, 196,0.2)',

      color: 'white',
      // border: '1px solid white',
    },
  },
  viewButton: {
    // color: '#505F79',
    color: '#fff',

    // background: 'rgba(196, 196, 196, 0.2)',
    background: '##272727',

    borderRadius: 3,
    fontSize: '9px',
    height: '35px',
    fontWeight: 'bold',
    margin: '0 5px',
    '&:hover': {
      color: 'white',
      borderBottom: '#fff',
    },
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '12px',
      textAlign: 'left',
    },
    '&  table thead tr th ': {
      fontWeight: 500,
      color: '#061938',
      padding: '9px',
      background: '#FFFFFF',
      textAlign: 'left',
    },
  },
  gridKenClass1: {
    '&  table tbody tr td ': {
      padding: '5px',
      textAlign: 'left',
    },
    '&  table thead tr th ': {
      fontWeight: 500,
      color: '#061938',
      padding: '9px',
      background: '#FFFFFF',
      textAlign: 'left',
    },
  },
  dialogHeader: {
    width: '100px',
  },
}));

const selectStatusOptionsUpcomomgExam = [
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'Incomplete',
    value: 'incomplete',
  },
  {
    label: 'Complete',
    value: 'complete',
  },
];

const selectStatusOptionsCompletedExam = [
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'Incomplete',
    value: 'incomplete',
  },
  {
    label: 'Complete',
    value: 'complete',
  },
];

const selectDueInOptions = [
  // {
  //   label: 'Select Due Date',
  //   value: '',
  // },
  {
    label: '7 Days',
    value: '7',
  },
  {
    label: '15 Days',
    value: '15',
  },
  {
    label: '30 Days',
    value: '30',
  },
];

const ExamDashboard = () => {
  const history = useHistory();
  const classes = useStyles();
  // const [selectStatusValueUpcomomgExam, setSelectStatusValueUpcomomgExam] =
  //   useState(selectStatusOptionsUpcomomgExam[0].value);

  const [selectDueInValueUpcomomgExam, setSelectDueInValueUpcomomgExam] =
    useState(selectDueInOptions[0].value);

  const [upcomingExamData, setUpcomingExamData] = useState([]);
  const [completedExamData, setcompletedExamData] = useState([]);
  const [examProgressData, setExamProgressData] = useState([]);
  const [studentInRiskData, setStudentInRiskData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectDueDaysValue, setDueDaysValue] = useState('');
  const [courseWithoutExam, setCourseWithoutExam] = useState([]);

  const handleSelectDueInChangeUpcomomgExam = (e) => {
    setSelectDueInValueUpcomomgExam(e.target.value);
  };

  /* const UpcomomgExamActionCell = (row) => {
    const { t } = useTranslation();

    console.log('rowrowrowrowrowrow', row.data);
    // const history = useHistory();
    let id;

    row.data.map((item) => {
      console.log('row.item', item);
    });
    const handleClickView = () => {
      console.log('${row.data.id}${row.data.id}', row.data.id);
      history.push(
        `/app/exam/questionPaper/question-paper-view/${row.data.id}`
      );
    };

    const handleClickSeatPlan = () => {
      history.push(`/app/exam/seatingPlan/arrangement/${row.data.id}`);
    };

    const handleClickSeatInvi = () => {
      history.push(`/app/exam/invigilationProctoring/${row.data.id}`);
    };

    const classes = useStyles();
    const { question_paper, seating_plan, invigilation } = row.row.values;

    return (
      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          className={
            question_paper === 'Approved' ? classes.normal : classes.error
          }
          size="small"
          variant="primary"
          // component={Link}
          style={{ padding: '0px 15px', height: '23px' }}
          onClick={handleClickView}
        >
          Qstn Paper
        </Button>

        <Button
          className={
            seating_plan === 'Created' ? classes.normal : classes.error
          }
          size="small"
          variant="primary"
          // component={Link}
          style={{ padding: '5px 15px', height: '23px' }}
          onClick={handleClickSeatPlan}
        >
          Seat Plan
        </Button>
        <Button
          className={
            invigilation === 'Assigned' ? classes.normal : classes.error
          }
          size="small"
          variant="primary"
          onClick={handleClickSeatInvi}
          // component={Link}
          style={{ padding: '5px 15px', height: '23px' }}
        >
          Invigilation
        </Button>
      </Box>
    );
  }; */

  const UpcomomgExamActionCell = (row) => {
    const { t } = useTranslation();

    // const history = useHistory();

    row.data.map((item) => {
      console.log('row.item', item);
    });

    const [onClosedata, setonClosedata] = useState(false);

    const onClosesss = () => {
      setonClosedata((prev) => {
        return !prev;
      });
    };

    const handleClickView = () => {
      console.log('${row.data.id}${row.data.id}', row.data.id);

      if (row.row.original.questionPaperId === null) {
        toast.error('There is no question paper availble right now ', {
          position: 'top-right',
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        history.push(
          `/app/exam/questionPaper/question-paper-view/${row.row.original.questionPaperId}`
        );
      }
    };

    const handleClickSeatPlan = () => {
      history.push(`/app/exam/seatingPlan/arrangement/${row.row.original.id}`);
    };

    const handleClickSeatInvi = () => {
      history.push(`/app/exam/invigilationProctoring/${row.row.original.id}`);
    };

    const classes = useStyles();
    const { question_paper, seating_plan, invigilation } = row.row.values;

    return (
      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        {/* <KenDialogBox
          title={
            <Typography variant="h6" className={classes.dialogHeader}>
              sdssd
            </Typography>
          }
          icon={<RiCheckFill />}
          open={onClosedata}
          handleClose={() => onClosesss()}
          hidePositiveButton
          negativeButtonClick={() => onClosesss()}
          negativeButtonText="Clear"
          dividers
        >
          sdssdsd
        </KenDialogBox> */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Button
          className={
            question_paper === 'Approved' ? classes.normal : classes.error
          }
          size="small"
          variant="primary"
          // component={Link}
          style={{ padding: '0px 15px' /* height: '23px'  */ }}
          onClick={handleClickView}
        >
          Qstn Paper
        </Button>
        <Button
          className={
            seating_plan === 'Created' ? classes.normal : classes.error
          }
          size="small"
          variant="primary"
          // component={Link}
          style={{ padding: '5px 15px' /* height: '23px'  */ }}
          onClick={handleClickSeatPlan}
        >
          Seat Plan
        </Button>
        <Button
          className={
            invigilation === 'Assigned' ? classes.normal : classes.error
          }
          size="small"
          variant="primary"
          onClick={handleClickSeatInvi}
          // component={Link}
          style={{ padding: '5px 15px' /* height: '23px' */ }}
        >
          Invigilation
        </Button>
      </Box>
    );
  };
  const CompletedExamActionCell = (row) => {
    const classes = useStyles();
    const { evaluation, grading } = row.row.values;

    const handleClickSeatEvu = () => {
      // history.push(`/app/exam/evaluation?course=${row.row.values.subject}`);
      history.push(`/app/exam/evaluation/${row.row.original.id}`);
    };

    const handleClickSeatGrading = () => {
      history.push(`/app/exam/grading/details/${row.row.original.id}`);
    };
    return (
      <Box>
        <Button
          className={
            !evaluation.includes('Not') ? classes.penddingButton : classes.error
          }
          size="small"
          variant="primary"
          // component={Link}
          // to={`${routes.currentProgrammes}/${id}/details`}
          onClick={handleClickSeatEvu}
          style={{ padding: '5px 15px' /* height: '23px' */ }}
        >
          Evaluator
        </Button>
        <Button
          className={!grading.includes('Not') ? classes.normal : classes.error}
          size="small"
          variant="primary"
          onClick={handleClickSeatGrading}
          // component={Link}
          style={{ padding: '5px 15px' /*  height: '23px' */ }}
        >
          Grading
        </Button>
      </Box>
    );
  };

  const RiskActionCell = (row) => {
    const classes = useStyles();
    const actions = row.row.values.actions;
    const handleClickSeatView = () => {
      history.push(`/app/exam/student-status`);
    };

    console.log('row.rowrow.rowrow.row', actions);
    return (
      <Box>
        <Button
          className={classes.grayButton}
          size="small"
          variant="primary"
          // component={Link}
          style={{ padding: '5px 15px', height: '23px' }}
          // onClick={handleClickSeatView}
          // href={actions}
        >
          View
        </Button>
      </Box>
    );
  };

  const ProgressActionCell = (row) => {
    const classes = useStyles();
    const { id, actions } = row.row.values;
    const [filterDialog, setFilterDialog] = useState(false);
    // const handleClickSeatView = () => {
    //   history.push(`/app/exam/`);
    // };

    function handleFilterDialog() {
      setFilterDialog((prevState) => !prevState);
    }

    const handleClickSeatGrading = () => {
      history.push(`/app/exam/faculty-Proctoring`);
    };
    return (
      <Box>
        <Button
          className={classes.grayLink}
          size="small"
          component={Link}
          style={{ padding: '5px 15px', height: '23px' }}
          // onClick={() => handleClickSeatGrading()}
          target="_blank"
          to={`${routes.webCamScreen}`}
        >
          View
        </Button>
        {/* <KenDialogBox
          title={
            <Typography variant="h6" className={classes.dialogHeader}>
              Web Cam
            </Typography>
          }
          icon={<RiCheckFill />}
          open={filterDialog}
          handleClose={() => handleFilterDialog()}
          negativeButtonClick={() => handleFilterDialog()}
          positiveButtonClick={() => handleFilterDialog()}
          positiveButtonText="Apply"
          negativeButtonText="Clear"
          maxWidth={'s'}
          dividers
        >
          <Webcam width={1100} height={450} />,
        </KenDialogBox> */}
      </Box>
    );
  };

  const SeatingPlanCell = (row) => {
    const classes = useStyles();
    const { seating_plan } = row.row.values;

    return (
      <Box
        className={
          seating_plan === 'Created' ? classes.greenText : classes.errorText
        }
      >
        {seating_plan}
      </Box>
    );
  };

  const QuestionPaperCell = (row) => {
    const classes = useStyles();
    const { question_paper } = row.row.values;

    console.log('rowrowrowrowrowrowrowrow', row);
    return (
      <Box
        className={
          question_paper === 'Approved' ? classes.greenText : classes.errorText
        }
      >
        {question_paper}
      </Box>
    );
  };

  const InvigilationCell = (row) => {
    const classes = useStyles();
    const { invigilation } = row.row.values;

    return (
      <Box
        className={
          invigilation === 'Assigned' ? classes.greenText : classes.errorText
        }
      >
        {invigilation}
      </Box>
    );
  };

  const EvaluationCell = (row) => {
    const classes = useStyles();
    const { evaluation } = row.row.values;

    return (
      <Box
        className={
          !evaluation.includes('Not') ? classes.greenText : classes.errorText
        }
      >
        {evaluation}
      </Box>
    );
  };

  const GradingCell = (row) => {
    const classes = useStyles();
    const { grading } = row.row.values;

    return (
      <Box
        className={
          !grading.includes('Not') ? classes.greenText : classes.errorText
        }
      >
        {grading}
      </Box>
    );
  };

  const columnsUpcomomgExam = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'Program',
      accessor: 'program',
      disableGlobalFilter: true,
    },
    {
      Header: 'Course',
      accessor: 'subject',
      disableGlobalFilter: true,
    },
    // {
    //   Header: 'Exam Cycle',
    //   accessor: 'examCycle',
    //   disableGlobalFilter: true,
    // },
    // {
    //   Header: 'Batch',
    //   accessor: 'batch',
    //   disableGlobalFilter: true,
    // },
    {
      Header: 'Term',
      accessor: 'Term',
      disableGlobalFilter: true,
    },
    {
      Header: 'Exam Type',
      accessor: 'Exam_Type',
      disableGlobalFilter: true,
    },
    {
      Header: 'Exam Date',
      accessor: 'exam_date',
      Cell: (props) => {
        const custom_date = props.value
          ? moment(props.value).format('DD-MM-YYYY')
          : '';
        return (
          <Typography style={{ fontSize: '12px' }}>{custom_date}</Typography>
        );
      },
      disableGlobalFilter: true,
    },
    {
      Header: 'Question Paper',
      accessor: 'question_paper',
      disableGlobalFilter: true,
      Cell: QuestionPaperCell,
    },
    {
      Header: 'Seating Plan',
      accessor: 'seating_plan',
      disableGlobalFilter: true,
      Cell: SeatingPlanCell,
    },
    {
      Header: 'Invigilation',
      accessor: 'invigilation',
      disableGlobalFilter: true,
      Cell: InvigilationCell,
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: UpcomomgExamActionCell,
    },
  ];

  const columnsCompletedExam = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'Program',
      accessor: 'program',
      disableGlobalFilter: true,
    },
    {
      Header: 'Course',
      accessor: 'subject',
      disableGlobalFilter: true,
    },
    // {
    //   Header: 'Exam Cycle',
    //   accessor: 'examCycle',
    //   disableGlobalFilter: true,
    // },
    // {
    //   Header: 'Batch',
    //   accessor: 'batch',
    //   disableGlobalFilter: true,
    // },
    {
      Header: 'Term',
      accessor: 'Term',
      disableGlobalFilter: true,
    },
    {
      Header: 'Exam Type',
      accessor: 'Exam_Type',
      disableGlobalFilter: true,
    },
    {
      Header: 'Exam Date',
      accessor: 'exam_date',
      Cell: (props) => {
        const custom_date = props.value
          ? moment(props.value).format('DD-MM-YYYY')
          : '';
        return (
          <Typography style={{ fontSize: '12px' }}>{custom_date}</Typography>
        );
      },

      disableGlobalFilter: true,
    },
    {
      Header: 'Evaluator',
      accessor: 'evaluation',
      disableGlobalFilter: true,
      Cell: EvaluationCell,
    },
    {
      Header: 'Grading',
      accessor: 'grading',
      disableGlobalFilter: true,
      Cell: GradingCell,
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: CompletedExamActionCell,
    },
  ];

  const columnsRisk = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'ID',
      accessor: 'IDs',
      disableGlobalFilter: true,
    },
    {
      Header: 'Name',
      accessor: 'name',
      disableGlobalFilter: true,
    },
    {
      Header: 'Reason',
      accessor: 'reason',
      disableGlobalFilter: true,
    },

    {
      Header: 'View Details',
      accessor: 'actions',
      Cell: RiskActionCell,
    },
  ];

  const columnsCourseWithoutExam = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'Progarm',
      accessor: 'programName',
      disableGlobalFilter: true,
    },
    {
      Header: 'Term Name',
      accessor: 'termName',
      disableGlobalFilter: true,
    },
    {
      Header: 'Course',
      accessor: 'courseName',
      disableGlobalFilter: true,
    },

    // {
    //   Header: 'View Details',
    //   accessor: 'actions',
    //   Cell: RiskActionCell,
    // },
  ];

  const columnsProgress = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'Program',
      accessor: 'program',
      disableGlobalFilter: true,
    },
    {
      Header: 'Course',
      accessor: 'subject',
      disableGlobalFilter: true,
    },
    {
      Header: 'Exam Date',
      accessor: 'examDate',
      disableGlobalFilter: true,
    },
    // {
    //   Header: 'Exam Cycle',
    //   accessor: 'examCycle',
    //   disableGlobalFilter: true,
    // },
    // {
    //   Header: 'Batch',
    //   accessor: 'batch',
    //   disableGlobalFilter: true,
    // },
    {
      Header: 'Type',
      accessor: 'type',
      disableGlobalFilter: true,
    },
    {
      Header: 'Venue / Link',
      accessor: 'actions',
      Cell: ProgressActionCell,
    },
  ];

  // const [selectStatusValueCompletedExam, setSelectStatusValueCompletedExam] =
  //   useState(selectStatusOptionsCompletedExam[0].value);

  const [selectDueInValueCompletedExam, setSelectDueInValueCompletedExam] =
    useState(selectDueInOptions[0].value);

  // const handleSelectStatusChangeCompletedExam = (e) => {
  //   setSelectStatusValueCompletedExam(e.target.value);
  // };

  const handleSelectDueInChangeCompletedExam = (e) => {
    setSelectDueInValueCompletedExam(e.target.value);
  };

  const [viewAll, setviewAll] = useState(false);
  const [viewCompletedAll, setCompletedviewAll] = useState(false);
  const [viewPendingAll, setPendingviewAll] = useState(false);
  const [viewInprogressAll, setInprogressviewAll] = useState(false);
  const [viewStdRiskAll, setStdRiskviewAll] = useState(false);

  const onViewAllCompleted = () => {
    setCompletedviewAll(true);
    history.push('/app/exam/completedExams');
  };

  const onViewAllPendding = () => {
    setPendingviewAll(true);
    history.push('/app/exam/Upcoming');
  };

  const onViewAllInprogress = () => {
    history.push('/app/exam/ExamProgress');
    setInprogressviewAll(true);
  };

  const onViewAllStdRisk = () => {
    setStdRiskviewAll(true);
    history.push('/app/exam/Coursewithoutexam');
  };

  let completedExamDataWithLimit;

  const getExamDatsa = () => {
    let filterData = {
      comduedays: selectDueInValueCompletedExam,
      pendingDueDate: selectDueInValueUpcomomgExam,
    };
    setLoading(true);

    getExamData(filterData)
      .then((res) => {
        setLoading(false);
        console.log('resresresresresForExam', res);
        let dataUpcomingExam =
          res.pendingExamList === null
            ? []
            : res.pendingExamList.map((item, index) => {
                return {
                  id: item?.id,
                  program: item.program ? item.program : 'N/A',
                  subject: item.course ? item.course : 'N/A',
                  Term: item.term ? item.term : 'N/A',
                  Exam_Type: item.examType ? item.examType : 'N/A',
                  exam_date: item.examDate ? item.examDate : 'N/A',
                  question_paper: item.quesPaperStatus
                    ? item.quesPaperStatus
                    : 'N/A',
                  seating_plan: item.seatPlanStatus
                    ? item.seatPlanStatus
                    : 'N/A',
                  invigilation: item.invigStatus ? item.invigStatus : 'N/A',
                  dataUpcomingExam: item,
                  questionPaperId: item?.questionPaperId,
                  batch: item.batch ? item.batch : '',
                  examCycle: item.examCycle ? item.examCycle : '',
                };
              });
        setUpcomingExamData(dataUpcomingExam);

        let datacompletedExam =
          res.completedExamList === null
            ? []
            : res.completedExamList.map((item, index) => {
                return {
                  id: item?.id,
                  program: item.program ? item.program : 'N/A',
                  subject: item.course ? item.course : 'N/A',
                  Term: item.term ? item.term : 'N/A',
                  Exam_Type: item.examType ? item.examType : 'N/A',
                  exam_date: item.examDate ? item.examDate : 'N/A',
                  evaluation: item.evaluation ? item.evaluation : 'Not Started',
                  grading: item.grading ? item.grading : 'Not Submitted',
                  datacompletedExam: item,
                  questionPaperId: item?.questionPaperId,
                  // batch: item.batch ? item.batch : '',
                  // examCycle: item.examCycle ? item.examCycle : '',
                };
              });

        setcompletedExamData(datacompletedExam);

        let dataExamInProgress =
          res.inProgressExamList === null
            ? []
            : res.inProgressExamList.map((item, index) => {
                console.log('itemitemitemitem', item);
                return {
                  id: item?.id,
                  program: item.program ? item.program : 'N/A',
                  subject: item.course ? item.course : 'N/A',
                  type: item.examType ? item.examType : 'N/A',
                  actions: item.examLink ? item.examLink : 'Venue',
                  // batch: item.batch ? item.batch : '',
                  // examCycle: item.examCycle ? item.examCycle : '',
                  examDate: item.examDate ? item.examDate : '',
                };
              });
        setExamProgressData(dataExamInProgress);
      })
      .catch((err) => {
        setLoading(false);
        console.log('err', err);
      });

    getCourseWithoutExam()
      .then((res) => {
        setLoading(false);
        let courseWithoutExamData =
          res === null
            ? []
            : res?.map((item, index) => {
                return {
                  id: item?.id,
                  programName: item.programName ? item.programName : 'N/A',
                  courseName: item.courseName ? item.courseName : 'N/A',
                  termName: item.termName ? item.termName : '-',
                };
              });

        setCourseWithoutExam(courseWithoutExamData);
      })
      .catch((err) => {
        setLoading(false);
        console.log('err', err);
      });
  };

  useEffect(() => {
    getExamDatsa();
    setLoading(true);

    // getStudentRiskDataData()
    //   .then((res) => {
    //     setLoading(false);
    //     let dataStudentRisk = [];
    //     // const newRes1 = [res[0], res[1]];

    //     res.map((item, index) => {
    //       dataStudentRisk.push({
    //         id: index + 1,
    //         IDs: item.rollNumber ? item.rollNumber : 'N/A',
    //         name: item.name ? item.name : 'N/A',
    //         reason: item.reason ? item.reason : 'N/A',
    //         actions: item.url ? item.url : 'N/A',
    //       });
    //     });
    //     setStudentInRiskData(dataStudentRisk);
    //   })
    //   .catch((err) => {
    //     console.log('err', err);
    //   });
  }, [
    selectDueInValueCompletedExam,

    selectDueInValueUpcomomgExam,
    viewPendingAll,
    viewCompletedAll,
  ]);

  completedExamDataWithLimit =
    completedExamData === null ? [] : completedExamData.slice(0, 5);
  const progressExamDataWithLimit =
    examProgressData === null ? [] : examProgressData.slice(0, 5);
  const UpcomingExamDataWithLimit =
    upcomingExamData === null ? [] : upcomingExamData.slice(0, 5);
  const viewStdRiskAllData = courseWithoutExam.slice(0, 5);

  return (
    <>
      <Box>
        {loading && <KenLoader />}

        <Box className={`${classes.breadCrumbWrapper} ${'breadCrumbText'}`}>
          <BreadCrumb
            className="breadCrumbText"
            array={arrayBreadCrumb}
            history={history}
          />
        </Box>
        <AppBar position="static" elevation={0} className={classes.header}>
          <Toolbar
            style={{
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h6" className={classes.title}>
              Exam Dashboard
            </Typography>
            <Grid
              item
              xs={6}
              style={{ display: 'flex', justifyContent: 'end' }}
            >
              {/* <Button
                startIcon={<MessageIcon />}
                variant="contained"
                color="primary"
                className={classes.addButton}
                component={Link}
                to={'#'}
                style={{ marginRight: '15px' }}
              >
                Send Message
              </Button> */}
              {/* <Button
                startIcon={<AnnouncementIcon />}
                variant="contained"
                color="primary"
                className={classes.addButton}
                onClick={() => {
                  sendMailExamData();
                }}
              >
                Annnouncements
              </Button> */}
            </Grid>
          </Toolbar>
        </AppBar>

        <Box className={`${classes.gridKenClass} cardlsitbox`}>
          <HeaderGrid
            title="Upcoming Exams"
            count={upcomingExamData.length}
            // selectStatusOptions={selectStatusOptionsUpcomomgExam}
            // selectStatusValue={selectStatusValueUpcomomgExam}
            // handleSelectStatusChange={handleSelectStatusChangeUpcomomgExam}
            selectDueInOptions={selectDueInOptions}
            selectDueInValue={selectDueInValueUpcomomgExam}
            handleSelectDueInChange={handleSelectDueInChangeUpcomomgExam}
            columns={columnsUpcomomgExam}
            data={viewPendingAll ? upcomingExamData : UpcomingExamDataWithLimit}
            onViewAll={onViewAllPendding}
          />
        </Box>
        <Box className={`${classes.gridKenClass1} cardlsitbox`}>
          <HeaderGrid
            title="Completed Exams"
            count={completedExamData.length}
            // selectStatusOptions={selectStatusOptionsCompletedExam}
            // selectStatusValue={selectStatusValueCompletedExam}
            // handleSelectStatusChange={handleSelectStatusChangeCompletedExam}
            selectDueInOptions={selectDueInOptions}
            selectDueInValue={selectDueInValueCompletedExam}
            handleSelectDueInChange={handleSelectDueInChangeCompletedExam}
            columns={columnsCompletedExam}
            data={
              viewCompletedAll ? completedExamData : completedExamDataWithLimit
            }
            onViewAll={onViewAllCompleted}
          />
        </Box>

        <Grid
          container
          spacing={2}
          rowSpacing={1}
          columnSpacing={{ xs: 3, sm: 2, md: 3 }}
        >
          <Grid item xs={6}>
            <Box className={`${classes.gridKenClass} cardlsitbox`}>
              {/* <HeaderGrid
                title="Student at Risk"
                count={studentInRiskData.length}
                columns={columnsRisk}
                data={viewStdRiskAll ? studentInRiskData : viewStdRiskAllData}
                onViewAll={onViewAllStdRisk}
              /> */}

              <HeaderGrid
                title="Course Without Exam"
                count={courseWithoutExam.length}
                columns={columnsCourseWithoutExam}
                data={viewStdRiskAll ? courseWithoutExam : viewStdRiskAllData}
                onViewAll={onViewAllStdRisk}
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className={`${classes.gridKenClass} cardlsitbox`}>
              <HeaderGrid
                title="Exams in Progress"
                columns={columnsProgress}
                count={examProgressData.length}
                data={
                  viewInprogressAll
                    ? examProgressData
                    : progressExamDataWithLimit
                }
                onViewAll={onViewAllInprogress}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ExamDashboard;
